/**
 * Shared constants + helpers for the Flow Builder pages.
 * Extracted from FlowsPage.jsx (iter82 refactor) so individual components
 * (NewFlowWizard, FlowCanvas, etc.) can be split into their own files
 * without copy-pasting these tables.
 */

export const API = `${process.env.REACT_APP_BACKEND_URL}/api/v1/flows`;

export const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem("session_token")}`,
});

// Categories shown in the New-Flow Wizard. Order matters — keep in sync with
// the backend TRIGGER_CATALOGUE.
export const CT_CATEGORIES = [
  "Sales", "Field Force", "Operations", "Finance", "HR", "Intelligence", "Scheduled", "Custom",
];

export const CT_SUBCATEGORIES = {
  "Sales":         ["Orders", "Dealers", "Schemes", "Other"],
  "Field Force":   ["Attendance", "GPS", "Visits", "Other"],
  "Operations":    ["Dispatch", "Delivery", "Other"],
  "Finance":       ["Collections", "Outstanding", "Other"],
  "HR":            ["Leaves", "Expenses", "Grievances", "Other"],
  "Intelligence":  ["Targets", "Leaderboard", "Other"],
  "Scheduled":     ["Daily", "Weekly", "Monthly", "Other"],
  "Custom":        ["General", "Webhook", "Integration", "Other"],
};

// Visual metadata per category (icon imported from lucide where used).
// Importers usually pull a single key — kept as object literal so we can extend
// without changing call sites.
import {
  ShoppingCart, Users, Building2, Wallet, Briefcase, BarChart3, Calendar,
} from "lucide-react";

export const CATEGORY_META = {
  "Sales":         { color: "#8B1A1A", bg: "#FAEDED", icon: ShoppingCart, blurb: "Orders, dealers, schemes" },
  "Field Force":   { color: "#0EA5E9", bg: "#E0F2FE", icon: Users,        blurb: "Attendance, GPS, visits" },
  "Operations":    { color: "#22C55E", bg: "#EAF3DE", icon: Building2,    blurb: "Dispatch, delivery" },
  "Finance":       { color: "#F59E0B", bg: "#FAEEDA", icon: Wallet,       blurb: "Collections, outstanding" },
  "HR":            { color: "#8B5CF6", bg: "#EEEDFE", icon: Briefcase,    blurb: "Leaves, expenses, grievances" },
  "Intelligence":  { color: "#EC4899", bg: "#FCE7F3", icon: BarChart3,    blurb: "Targets, leaderboard" },
  "Scheduled":     { color: "#6B7280", bg: "#F1EFE8", icon: Calendar,     blurb: "Daily, weekly, monthly" },
};
